export default "__VITE_ASSET__DhXE_DP8__"